import { KnownProjectDtoProjectType } from '@groundfloor-platform/mgmt-service-g-sdk';

/**
 * Carriers and regions manage couriers rather than customers/occupants, so their
 * users navigation item points at the couriers list instead.
 */
export function isCarrierProjectType(projectType?: string): boolean {
  return projectType === KnownProjectDtoProjectType.Carrier || projectType === KnownProjectDtoProjectType.Region;
}

/** Carriers are managed at the network level; its sites hold the occupants and hubs. */
export function isNetworkProjectType(projectType?: string): boolean {
  return projectType === KnownProjectDtoProjectType.Network;
}
